import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';
import { Config } from '@formunauts/shared/data-access';
import { SupporterFeedbackFormRepository } from './supporter-feedback-data-access.model';
import {
  SupporterFeedbackFormApiRepository,
  SupporterFeedbackFormApiRepositoryConfig,
} from './supporter-feedback-form-api-repository';

export function provideSupporterFeedbackDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([
    SupporterFeedbackFormApiRepository,
    {
      provide: SupporterFeedbackFormRepository,
      useExisting: SupporterFeedbackFormApiRepository,
    },
    {
      provide: SupporterFeedbackFormApiRepositoryConfig,
      useFactory: (timeoutCfg = inject(Config.Timeout)) =>
        new SupporterFeedbackFormApiRepositoryConfig({
          timeout: timeoutCfg.general,
        }),
    },
  ]);
}
